import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InputGroup } from 'react-bootstrap';
import { DropdownList } from 'react-widgets';

const getFilter = (filter) => {
  if (filter) {
    if (filter === true) {
      return 'contains';
    }
    return filter;
  }
  return false;
};

class LanguageSelectorNoForm extends Component {
  render() {
    const { filter, ...rest } = this.props;
    const definedFilter = getFilter(filter);
    return (
      <InputGroup>
        <InputGroup.Addon>
          <i className="fa fa-language fa-lg" aria-hidden="true" />
        </InputGroup.Addon>
        <DropdownList {...rest} filter={definedFilter} textField="label" valueField="value" />
      </InputGroup>
    );
  }
}

LanguageSelectorNoForm.propTypes = {
  filter: PropTypes.string,
};

LanguageSelectorNoForm.defaultProps = {
  filter: null,
};

export default LanguageSelectorNoForm;
